/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-22 19:57:27
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-05-21 16:11:31
 * @FilePath: /designcenter/src/api/modules/topologyGraph.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'

const request = getApiRequest()

// 获取拓扑图数据
export async function getTopologyGraphData(data: any) {
  return request.post<IRes<unknown>>('/design/topology/diagram', data)
}

//获取产品详情
export async function getProductDetail(id: string) {
  return request.get<IRes<unknown>>(`/design/product/parameter/${id}`)
}

//保存拓扑图
export async function saveTopologyGraph(data: any) {
  return request.post<IRes<unknown>>('/design/topology/saveProjectDiag', data)
}

//切换模板创建项目
export async function createProjectByTemplate(data: any) {
  return request.post<IRes<unknown>>('/design/topology/createNewDiag', data)
}

// 获取线缆列表
export async function getCableList(data: any) {
  return request.post<IRes<unknown>>('/design/cable/list', data)
}

//创建分享副本
export async function createShareCopy(data: any) {
  return request.post<IRes<unknown>>('/design/topology/copyDiagram', data)
}

//修改组件
export async function updateComponent(data: any) {
  return request.post<IRes<unknown>>('/design/component/update', data)
}

//获取产品列表
export async function getProductList(data: any) {
  return request.post<IRes<unknown>>('/design/product/list', data)
}

// 获取查看产品清单
export async function getTemplateChecklist(params: any) {
  return request.get<IRes<unknown>>(`/design/template/checklist`, { params })
}

//切换模板覆盖当前项目
export async function coverTemplateProject(data: any) {
  return request.post<IRes<unknown>>('/design/topology/cover', data)
}
